import * as Sentry from '@sentry/react';
import { ExtraErrorData as ExtraErrorDataIntegration } from '@sentry/integrations';
import { BrowserTracing } from '@sentry/tracing';

// Only enable for Test, Beta, and Prod
// Check host to make sure it isn't a local, qa, or dev with the feature flag enabled.
const isEnvEnabled = () => {
    const host = window.location.host;
    return host === 'connect.garmin.com' || host === 'connecttest.garmin.com';
};

const getEnv = () => {
    const host = window.location.host;
    if (host === 'connect.garmin.com') {
        if (window.jQuery('.beta-tag').length > 0) {
            return 'beta';
        } else {
            return 'prod';
        }
    } else if (host === 'connecttest.garmin.com') {
        return 'test';
    }
};

/**
 * We'll now be testing out the Dynamic Sampling feature of Sentry, so we'll return 100% of traces.
 * https://docs.sentry.io/product/data-management-settings/dynamic-sampling/getting-started/
 */
const getTracesSampleRate = () => {
    return 1;
};

const setPUserTag = (userRoles) => {
    const spFeatureRegEx = /^ROLE_SP_FEATURE_[1-8]$/gm;
    const isPUser = userRoles.some((role) => role.match(spFeatureRegEx));

    Sentry.setTag('pUser', isPUser);
};

if (window.JS_ERROR && isEnvEnabled()) {
    Sentry.init({
        dsn: 'https://f0377f25d5534ad589ab3a9634f25e71@o430870.ingest.sentry.io/5591783',
        environment: getEnv(),
        tracesSampleRate: getTracesSampleRate(),
        release: `connect@${process.env.REACT_APP_VERSION}`,
        normalizeDepth: 5,
        integrations: [
            new ExtraErrorDataIntegration({
                // limit of how deep the object serializer should go. Anything deeper than limit will
                // be replaced with standard Node.js REPL notation of [Object], [Array], [Function] or
                // a primitive value. Defaults to 3.
                depth: 5
            }),
            new BrowserTracing({
                beforeNavigate: (context) => {
                    return {
                        ...context,
                        name: window.location.pathname
                            .replace(/[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}/g, '<guid>')
                            .replace(/[0-9]{4}-[0-9]{2}-[0-9]{2}/g, '<date>')
                            .replace(/\/[a-fA-F0-9]{32}/g, '/<hash>')
                            .replace(/\/\d+/g, '/<digits>')
                    };
                }
            })
        ]
    });

    if (window.VIEWER_SOCIAL_PROFILE) {
        if (window?.VIEWER_SOCIAL_PROFILE?.userRoles?.length > 0) {
            setPUserTag(window.VIEWER_SOCIAL_PROFILE.userRoles);
        }

        Sentry.setUser({ id: window.VIEWER_SOCIAL_PROFILE.garminGUID });
    }
}
